const AssetAllocationsTable = require('./AssetAllocationsTable');

module.exports = AssetAllocationsTable;
